import React, { useMemo } from 'react';
import { analyticService } from 'global/services';

interface IObserverProps {
    dishesArray: any[],
    analyticsHandler: (dish: any) => void,
}

const observerOptions = {
    rootMargin: '0px',
    threshold: 0.45,
};

export const useProductImpressionObserver = ({
    dishesArray,
    analyticsHandler,
}: IObserverProps) => {
    const dishObserver = useMemo(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
                if (e.isIntersecting) {
                    const isMaxiBlock = Array
                        .from(e.target.classList)
                        .some((className) => className
                            .includes('maxiBlockRoot'));
                    const isProgrammaticScrollFlag = sessionStorage.getItem('isProgrammaticScroll');
                    const isProgrammaticScroll = isProgrammaticScrollFlag
                        ? JSON.parse(isProgrammaticScrollFlag)
                        : false;
                    if (isMaxiBlock) {
                        analyticService.push({
                            eventName: 'Product_Impression',
                            dish: [],
                            dishIndex: null,
                            source_name: window.location.pathname,
                            isMaxiBlock: true,
                        });
                        return;
                    }
                    if (isProgrammaticScroll) return;
                    const target = e.target as HTMLElement;
                    const intersectingDish = dishesArray
                        .filter((dish) => dish.id === target.dataset.id);
                    analyticsHandler(intersectingDish);
                }
            });
        }, observerOptions);
        return observer;
    }, [dishesArray, analyticsHandler]);
    return [dishObserver];
};
